import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Voucher';

const Voucher = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Voucher Perawatan" title="Daftar Voucher Perawatan" />
            <DefaultContain />
        </Fragment>
    );
};
export default Voucher;